<template>
  <div class="flex flex-col gap-6">
    <!-- Large checkmark at the top -->
    <div class="flex justify-center my-2 md:my-4">
      <img src="/tick.png" alt="Checkmark" class="w-10 h-10 lg:w-16 lg:h-16" />
    </div>
    
    <!-- Main title with custom font -->
    <Typography size="main-l" class="text-center leading-none text-nowrap text-white font-bold">
      You are elegible for the following rewards:
    </Typography>
        <!-- Rewards list horizontal -->
    <div class="flex flex-row justify-center gap-8 my-6">
      <!-- Seed NFT -->
      <div class="flex items-center gap-2" :class="{ 'opacity-50': !eligibility?.nft }">
        <img src="/tick.png" alt="Checkmark" class="w-5 h-5" />
        <Typography size="secondary-lg" class="text-white">Seed NFT</Typography>
      </div>

      <!-- Apecoin -->
      <div class="flex items-center gap-2" :class="{ 'opacity-50': !eligibility?.apecoin }">
        <img src="/tick.png" alt="Checkmark" class="w-5 h-5" />
        <Typography size="secondary-lg" class="text-white">Apecoin</Typography>
      </div>

      <!-- Badges -->
      <div class="flex items-center gap-2" :class="{ 'opacity-50': !eligibility?.badge }">
        <img src="/tick.png" alt="Checkmark" class="w-5 h-5" />
        <Typography size="secondary-lg" class="text-white">Badges</Typography>
      </div>
    </div>
    <Typography size="secondary-lg" class="text-white">ApeChain Airdrop wallet: {{ userData.apechain_wallet }}</Typography>
    <!-- Action buttons -->
    <div class="flex flex-col gap-3">
      <!-- Share on X button -->
      <button 
        class="bg-black text-white font-bold px-6 py-2 mx-auto w-full max-w-sm hover:bg-opacity-90 transition-all border border-gray-600 flex items-center justify-center gap-2"
        @click="shareOnX">
        <Typography size="main-l" class="font-bold">Share on </Typography>
        <img src="~/assets/svg/x-logo-twiter.svg" alt="X Logo" class="w-5 h-5" />
      </button>
    </div>
  </div>
</template>
  
<script setup>
import Typography from "@/components/common/Typography.vue"
import { useModalsStore } from '../../stores/useModalsStore'
import { useAuthStore } from '../../stores/useAuthStore'
import { computed } from 'vue'

const modalsStore = useModalsStore()
const authStore = useAuthStore()
debugger
// Obtener los datos de elegibilidad del payload del modal
const eligibility = computed(() => modalsStore.modalPayload)
const userData = computed(() => authStore.user.directusUser)

const closeModal = () => {
  modalsStore.closeModal()
}

const shareOnX = () => {
  let tweetText = "I just set my wallet in albarra.world to receive the airdrop of my @albarra_tdrc pilot season rewards! 🪵🪓"
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`
  window.open(twitterUrl, '_blank', 'width=550,height=420')
  modalsStore.closeModal()
}
</script>
  
<style scoped>
</style>
